// extracted by mini-css-extract-plugin
export default {"mainContentContainer":"styles_mainContentContainer__nPssv","sectionContainer":"styles_sectionContainer__NQKBQ"};